export const ColumnIds = {
  name: "name",
  jobType: "jobType",
  displayOrder: "displayOrder",
  code: "code",
} as const;
